import { render, staticRenderFns } from "./MessengerMessage.vue?vue&type=template&id=48286301&scoped=true&"
import script from "./MessengerMessage.vue?vue&type=script&lang=js&"
export * from "./MessengerMessage.vue?vue&type=script&lang=js&"
import style0 from "./MessengerMessage.vue?vue&type=style&index=0&id=48286301&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48286301",
  null
  
)

export default component.exports